export enum EntityType {
  None = 0,
  Ticket = 1,
  EmailMessage = 2,
  User = 3,
  Staff = 4,
  TimelineActivity = 5,
}
